<template>
  <div>
    <div :class="['detail-item-view', 'flex', 'flex-col', 'text-16', border && 'border']" v-if="flex === 'col'">
      <template v-if="hasTitleRight">
        <div class="flex justify-between">
          <span class="text-label leading-24" :class="getColon() ? '' : 'mr-8'">
            {{ label }}
          </span>
          <slot name="titleRight"></slot>
        </div>
      </template>
      <template v-else>
        <span class="text-label leading-24" :class="getColon() ? '' : 'mr-8'">
          {{ label }}
        </span>
      </template>

      <template v-if="!$slots.default">
        <template v-if="type === 'img'">
          <div v-if="type === 'img'" :class="['grid', `grid-cols-${cols}`, 'gap-15', 'mt-10']">
            <template v-if="value.length">
              <van-image
                :style="{ height: '105px', border: cols === 1 ? '1px dashed #E1E3E5' : '' }"
                v-for="(item, index) in value"
                :key="index"
                :src="item.photo_file"
                @click="handleImg(value, index)"
              />
            </template>
            <template v-else><span>-</span></template>
          </div>
        </template>
        <template v-else>
          <div v-if="hasArrow" class="flex justify-between items-center mt-10">
            <span class="break-all mt-[5px] truncate leading-24" :class="getColor()">{{ value || "-" }}</span>
            <van-icon class="ml-auto" name="arrow" color="#999" />
          </div>
          <span v-else class="break-all mt-10 leading-24" :class="getColor()">{{ value || "-" }}</span>
        </template>
      </template>
      <slot v-else></slot>
    </div>

    <div class="mb-10 flex items-center text-16" v-else>
      <span class="text-label leading-24" :class="getColon() ? '' : 'mr-8'">
        {{ label }}
      </span>
      <template v-if="!$slots.default">
        <template v-if="type === 'tel'">
          <a class="text-theme" :href="`tel:${value}`">{{ value }}</a>
        </template>
        <span class="flex-1 break-all leading-24" :class="getColor()" v-else>{{ value || "-" }}</span>
      </template>
      <slot v-else></slot>
    </div>

    <van-image-preview closeable v-model:show="showImagePreview" :images="imageList" :startPosition="startPosition" />
  </div>
</template>
<script setup>
import { ref } from "vue";
const props = defineProps({
  label: { default: "" },
  value: { default: "" },
  isBlue: { default: false },
  flex: { default: "row" },
  type: { default: "" },
  border: { default: true },
  hasArrow: { default: false },
  hasTitleRight: { default: false },
  cols: { default: 3 }
});

const getColon = () => {
  return props.label.includes("：");
};

const getColor = () => {
  return !props.isBlue ? "text-default" : "text-theme";
};

const showImagePreview = ref(false);
const imageList = ref([]);
const startPosition = ref(0);

const handleImg = (list, index) => {
  showImagePreview.value = true;
  imageList.value = list.map(i => i.photo_file);
  startPosition.value = index;
};
</script>
<style lang="less" scoped>
.detail-item-view {
  margin-bottom: 15px;
  padding-bottom: 15px;
  .border {
    border: 1px solid #e1e3e5;
  }
}
</style>
